import DsService from './DsService';


module.exports = {
  DsService: new DsService(),
};
